import { useTranslation } from "../../i18n";
import { Button } from "../Button/Button";
import { useTableContext } from "./context";

export const Selection = () => {
  const { t } = useTranslation();
  const { pagination, selection, items } = useTableContext();

  const hasSelection =
    selection && (selection.selectAll || selection.selectedItems.length > 0);
  const totalItems = pagination?.totalItems || items.length;
  const itemsOnCurrentPage = items.length;

  if (!hasSelection) {
    return null;
  }

  return (
    <div className="flex items-center gap-4">
      <span className="text-xs text-neutral-500">
        {selection.selectAll
          ? t("table.selectionSummaryAll", { total: totalItems })
          : t("table.selectionSummary", {
              count: selection.selectedItems.length,
              total: itemsOnCurrentPage,
            })}
      </span>
      {selection.showSelectAllButton &&
        !selection.selectAll &&
        selection.onSelectAll && (
          <Button size="xs" variant="outlined" onClick={selection.onSelectAll}>
            {t("table.selectAllButton", { total: totalItems })}
          </Button>
        )}
    </div>
  );
};
